// extracted by mini-css-extract-plugin
module.exports = {"noDisplay":"VisualitzacioTipus_noDisplay__WLw4b"};